import { Button } from '@warp-ds/react';
import { useState } from 'react';
import { trackCreateOrRepublishAdButton } from '@/utils/tracking';

export const PublishButton = () => {
    const [loading, setLoading] = useState(false);
    const createAdUrl = '/realestate/private/item/create?adType=realestate-letting';
    return (
        <Button
            onClick={() => {
                setLoading(true);
                trackCreateOrRepublishAdButton('finn', null, true);
                window.location.href = createAdUrl;
                setTimeout(() => {
                    setLoading(false);
                }, 10000);
            }}
            loading={loading}
            fullWidth
            type="button">
            Ny annonse på FINN
        </Button>
    );
};
